export const SIZES = {
    mobileWidth: 768,
    boardContainerMobileHeight: 200,
    isMobileDevice: function () {
        return window.innerWidth < this.mobileWidth ? true : false;
    }

    ,
    svgFontSmall: "0.6rem",
    svgFont: "0.8rem",
    svgFontMedium: "0.9rem",
    svgFontLarge: "1.1rem",
    fontMedium: "1.1rem"
}